<template>
	<div class="table-div">
		<!-- <div class="th-div">
			<div>{{ $t('类型') }}</div>
			<div>{{ $t('金额') }}</div>
		</div> -->
		<div class="tr-div" v-for="(item, index) in list" :key="item.id" :class="[`tr${index}`]">
			<div class="td1">
				<div>{{ item.account }}</div>
				<div style="font-size: 12px;color: #888888;margin-top: 5px;">{{ item.createtime_text }}</div>
			</div>
			<div class="td2 txt-ali-cen truncate2">{{ item.type_text }}</div>
			<div class="txt-ali-rig" :style="{ color: item.money >= 0 ? '#00f0ff' : '#ff4834' }">
				<div>{{ item.money }}</div>
				<div>{{ item.coin_name }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		list: {
			type: Array,
			default: () => []
		},
	},
	components: {},
	data() {
		return {};
	},
	mounted() { },

	methods: {}
};
</script>
<style lang="scss" scoped>
.table-div {
	padding: 10px 0px;

	.th-div {
		display: flex;
		align-items: center;
		// margin-bottom: 30px;
		color: #5e5e7a;
		font-size: 12px;

		>div {
			flex: 1;
		}
	}

	.tr-div {
		border-bottom: 1px solid #222b39;
		padding: 10px 0px;
		background: #000;
		display: flex;
		align-items: center;
		font-size: 14px;

		>div {
			flex: 1;
		}

		.td2 {
			width: 60%;
		}
	}
}
</style>